module.exports = __webpack_public_path__ + "static/img/logo-my-pa-box-white.6e1c7ea.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-my-pa-box-white.svg
// module id = OYF2
// module chunks = 1